import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme.semantic";

const ListItem = styled.li`
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  margin-right: ${props => props.marginRight};
  margin-left: ${props => props.marginLeft};
  padding-right: ${props => props.paddingRight};
  padding-left: ${props => props.paddingLeft};
  padding-top: ${props => props.paddingTop};
  padding-bottom: ${props => props.paddingBottom};
  border-top: ${props => props.borderTop};
  border-bottom: ${props => props.borderBottom};
  border-right: ${props => props.borderRight};
  border-left: ${props => props.borderLeft};
  line-height: ${props => props.lineHeight};
  height: ${props => props.height};
  vertical-align: ${props => props.verticalAlign};

  ${props =>
    props.separationLine
      ? `
    border-right: 0.75pt solid ${props.lineColor || "#e6e6e6"}; 
    padding: ${props.padding || "0 12px 0 12px"};
    &:last-child{
      padding-right: 0;
      border-right: none;
    }
    &:first-child{
      padding-left: 0;
    }
    `
      : null};
`;

ListItem.propTypes = {
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  borderTop: PropTypes.string,
  borderBottom: PropTypes.string,
  separationLine: PropTypes.bool,
  lineColor: PropTypes.string,
  padding: PropTypes.string
};

ListItem.defaultProps = {
  marginTop: "0",
  marginBottom: "0",
  paddingTop: "0",
  paddingBottom: "0",
  borderTop: "none",
  borderBottom: "none",
  separationLine: false,
  lineColor: theme.components.ListItem.lineColor,
  padding: "0 12px 0 12px"
};

export default ListItem;
